window.MarketingOverviewTable = (function() {

    var moTable = false;

    function exportTotals(index, data) {
        switch(index) {
            case 0:
                return 'Total';
                break;
            case 3:
                return data.total_login_count;
                break;
            case 4:
                return data.total_connections_sent_count;
                break;
            case 5:
                return data.total_connections_accepted_count;
                break;
            case 6:
                return data.total_emails_sent_count;
                break;
            case 7:
                return data.total_approved_flyers_count;
                break;
            case 8:
                return data.total_approved_postcards_count;
                break;
            case 9:
                return data.total_active_sites_count;
                break;
            case 10:
                return data.total_lead_count;
                break;
            default:
                return '';
        }
    }

    function buildFooter(table, data) {
        var sortCols = $.map($('th[data-name]'), function(value, i) {
            return $(value).attr('data-name');
        });
        for (var i = sortCols.length - 1; i >= 0; i--) {
            $( table.column(i).footer() ).html(
                exportTotals(i, data)
            );
        }
    }

    function buildModalLink(data, userId, target, cssClass) {
        var link = '';
        link += '<a href="javascript:;" class="' + cssClass + '" data-toggle="modal" data-target="' + target + '" data-user-id="' + userId + '">';
            link += data;
        link += '</a>';

        return link;
    }

    function setFilterVals(obj) {
        $.each(obj, function(key, value) {
            if(value){
                if ($.isPlainObject(value)) {

                    $.each(value, function(key2, value2) {
                        if(value2){
                            $('#js-filter-form [name="' + key + '[' + key2 + ']' + '"]').val(value2);
                        }
                    });
                } else {
                    $('#js-filter-form [name="' + key + '"]').val(value);
                    $('.selectpicker').selectpicker('render');
                }
            }
        });
    }

    function tableInit(tableClass, route) {

        moTable = $(tableClass).DataTable({
            dom:"<'row table-filter--pretty'<'col-sm-6'l><'col-sm-6'f>>" +
                "<'row'<'col-sm-12't>>" +
                "<'row table-footer--pretty'<'col-sm-5'i><'col-sm-7'p> r>",
            processing: true,
            language: {
                processing: '',
                search: '',
                searchPlaceholder: "Search",
                lengthMenu: '_MENU_'
            },
            paging:   true,
            lengthMenu: [ [10, 25, 50, 100, -1], [10, 25, 50, 100, "All"] ],
            pageLength: 50,
            serverSide: true,
            sAjaxDataProp: "users",
            scrollX: true,
            scrollY: 'calc(100vh - 317px)',
            scrollCollapse: true,
            deferRender: true,
            fnDrawCallback: function() {
                $('.user-info-popover').popover();
            },
            footerCallback: function(row, data, start, end, display) {
                var api = this.api();
                var data = this.api().ajax.json();
                buildFooter(api, data.totals);
            },
            ajax: {
                url: route,
                data: function(data) {
                    var hash = dataTableAjax.deparamQueryParams();

                    delete data.columns;
                    dataTableAjax.setHash(data);
                }
            },
            columns: [
                {
                    mData: null,
                    sTitle: "Name",
                    render: function(data, type, row) {
                        return xss(dataTableAjax.renderTemplate(data, '#mo-user-info'));

                    },
                    bSortable: true,
                },
                {
                    sTitle: "Teams",
                    mData: null,
                    render: function(data, type, full) {
                        if (type !== 'display') {
                            return data.teams;
                        }

                        if (data.teams.length > 50) {
                            return '<span title="' + data.teams + '">' + data.teams.substr(0, 47) + '...</span>';
                        }
                        return '<span>' + data.teams + '</span>';
                    },
                    bSortable: false
                },
                {
                    sTitle: "Last Login",
                    mData: function(source, type, val) {
                        return helpers.formatDate(source.last_login, 'MM/DD/YY');
                    },
                    bSortable: true
                },
                {
                    sTitle: "Login Count",
                    mData: function(source, type, val) {
                        return source.login_count;
                    },
                    bSortable: true
                },
                {
                    sTitle: "Connections Sent",
                    mData: null,
                    render: function(data, type, full) {
                        return buildModalLink(data.connections_sent_count, data.user_id, '#mo-details-modal', 'js-connections-sent-details');
                    },
                    bSortable: true
                },
                {
                    sTitle: "Connections Accepted",
                    mData: null,
                    render: function(data, type, full) {
                        return buildModalLink(data.connections_accepted_count, data.user_id, '#mo-details-modal', 'js-connections-accepted-details');
                    },
                    bSortable: true
                },
                {
                    sTitle: "Emails Sent",
                    mData: null,
                    render: function(data, type, full) {
                        return buildModalLink(data.emails_sent_count, data.user_id, '#mo-details-modal', 'js-emails-sent-details');
                    },
                    bSortable: true
                },
                {
                    sTitle: "Flyers",
                    mData: null,
                    render: function(data, type, full) {
                        if (data.approved_flyers_count === null) {
                            return buildModalLink(0, data.user_id, '#mo-details-modal', 'js-flyer-details');
                        } else {
                            return buildModalLink(data.approved_flyers_count, data.user_id, '#mo-details-modal', 'js-flyer-details');
                        }

                    },
                    bSortable: true
                },
                {
                    sTitle: "Postcards",
                    mData: null,
                    render: function(data, type, full) {
                        if (data.approved_postcards_count === null) {
                            return buildModalLink(0, data.user_id, '#mo-details-modal', 'js-postcard-details');
                        } else {
                            return buildModalLink(data.approved_postcards_count, data.user_id, '#mo-details-modal', 'js-postcard-details');
                        }
                    },
                    bSortable: true
                },
                {
                    sTitle: "Active Sites",
                    mData: null,
                    render: function(data, type, full) {
                        return buildModalLink(data.active_sites_count, data.user_id, '#mo-details-modal', 'js-active-site-details');
                    },
                    bSortable: true
                },
                {
                    sTitle: "Leads",
                    mData: null,
                    render: function(data, type, full) {
                        return data.lead_count;
                    },
                    bSortable: true
                }

            ]
        });
    }

    function setFilterVals(obj) {
        $.each(obj, function(key, value) {
            if(value){
                if ($.isPlainObject(value)) {

                    $.each(value, function(key2, value2) {
                        if(value2){
                            $('#js-filter-form [name="' + key + '[' + key2 + ']' + '"]').val(value2);
                        }
                    });
                } else {
                    $('#js-filter-form [name="' + key + '"]').val(value);
                }
            }
        });
        $('.selectpicker').selectpicker('render');
    }

    function init(tableClass, route) {

        $(function() {

            tableInit(tableClass, route);
            var params = moTable.ajax.params();

            moTable.on('preXhr', function(e, settings, data) {
                var data = moTable.ajax.params();
                dataTableAjax.setParams(data);

                window.location.hash = $.param(data);
            });

            moTable.one('xhr', function(e, settings, json, xhr) {
                moTable.search(params.search.value);
                moTable.page.len(params.length);
                moTable.column(10).visible(json.leads_access);
                moTable.search(params.search.value);
                moTable.page.len(params.length);
            });

            moTable.on('xhr', function(e, settings, json, xhr) {
                if(json) {
                    $('.js-total-count').html(json.recordsTotal);
                }
            });

            moTable.on('init', function() {
                if (params.sort) {
                    dataTableAjax.setSortOrder(params.sort);
                } else {
                    dataTableAjax.setSortOrder('creation_date');
                }
                setFilterVals(params);
            });

            moTable.on('init', function() {
                if (params.sort) {
                    dataTableAjax.setSortOrder(params.sort);
                } else {
                    dataTableAjax.setSortOrder('f_name');
                }
                setFilterVals(params);
            });

            var buttons = new $.fn.dataTable.Buttons(moTable, {
                 buttons: [
                    {
                        extend: 'csvHtml5',
                        className: 'hidden',
                        exportOptions: {
                            orthogonal: 'export',
                            format: {
                                footer: function(one, index, node) {
                                    return exportTotals(index, moTable.ajax.json().totals);
                                }
                            }
                        },
                        footer: true
                    }
                ]
            }).container().appendTo($('body'));

            $('.js-export-table').on('click', function() {
                $(buttons).find('.buttons-html5').trigger('click');
            });

            $('#js-loan-filter-btn').on('click', function() {
                moTable.ajax.reload();
            });

            $('.js-reset-loan-table').on('click', function() {
                dataTableAjax.resetParams(moTable);
            })

            $('.input-daterange').each(function() {
                $(this).datepicker({
                    inputs: $(this).find('input'),
                    keepEmptyValues: true
                });
            });

            // dataTableDropdown.init('.dataTable.table--pretty');

        });
    }

    return {
        init: init
    }

})();